import { useSelector } from "react-redux";
import { addFerriesData, ferriesDataSelector } from "../Redux/appStateSlice";
import { WithFetchJsonContent } from "./WithFetchJsonContent";

export const WithFerriesData = ({ children }) => {
  const hasFerryData = useSelector(ferriesDataSelector);

  return (
    <WithFetchJsonContent
      reduxInStore={hasFerryData}
      addToReduxFunction={addFerriesData}
      jsonLocation="content/ferries"
    >
      {children}
    </WithFetchJsonContent>
  );
};
